// juno/index.ts
import AboutImages from "./about";
import AiEngineImages from "./ai-engine";
import CompaniesImages from "./companies";
import junoLogo from "../logo/juno-logo.png";
import junoLogoMini from "../logo/juno-logo-mini.png";
import junoLogoMini2 from "../logo/juno-logo-mini2.png";

const Juno = {
  logo: junoLogo,
  mini: junoLogoMini,
  mini2: junoLogoMini2,
  about: AboutImages,
  aiEngine: AiEngineImages,
  companies: CompaniesImages,
};

export default Juno;

// 個別エクスポートは各サブモジュールから直接行われるため、
// ここでは再エクスポートしません
